export class TableValidState {

    /**
     * @type {Map<id, RowValidState>}
     */
    rowMap = new Map();
    /**
     * hat die Table keinen direkten Fehler?
     */
    valid = true;
    /**
     * hat die Table keinen transitiven Fehler?
     */
    transValid = true;

}
